import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'adizimo-oferta-page',
  templateUrl: './dizimo-oferta-page.component.html',
  styleUrls: ['./dizimo-oferta-page.component.scss']
})
export class DizimoOfertaPageComponent implements OnInit {

  public loader:any  = false; 
  public apelido = "dizimo-e-oferta"; 
  public response = {
    data: "",
    status: null
  }
  public page:any     = {};
  public params:any   = {};
  public dataItem:any = {}
  public message      = "Carregando. Aguarde!";
  public itensB       = [{
    text: "Contato"
  }];
  public options = [];

  constructor(
    private app: AppService,
    private api: ApiService  
  ){} 

  /**
   * 
   * Retorna os dados da página
   * 
   */
  getData(){

    try{

      this.message = "Enviando. Aguarde!";  
      this.loader  = true;

      this.api.conteudo().page(this.apelido).subscribe(response => {

        this.loader = false;   

        if(response.status == 1){
                
          if(typeof(response.data.page) != "undefined"){
            
            this.response = {  
              data: "",
              status: 1
            }

            this.page      = typeof(response.data.page.data[0]) != "undefined" ? response.data.page.data[0] : response.data.page.data;
            this.params    = this.page.params != null ? JSON.parse(this.page.params) : {};
            
            this.app.setMetaDados(this.page.meta_title,this.page.meta_description); 
              
          }
      
      
        }else{
          this.response = {
            data: response.data,
            status: 500 
          }
        }
        this.app.toTop(); 

      },(response) => {

        this.loader = false;
        this.app.toTop(); 
      
      });

    }catch(e){

      this.loader = false;

    }

  }
  /**
   * 
   * Set options
   * 
   * 
   **/
  setOptions(){

    this.options = [{
      name: "Depósito ou Transferência Bancária",
      icon: "account_balance",
      empresa: "Igreja Greenhouse",
      banco: "Banco Santander",
      agencia: "1109",
      conta: "13.001934-0",
      cnpj: "32.708.437/0001-70",
      type: 1,
      link: null,
      info: "Abaixo os dados da conta bancária:"
    },{
      name: "Pix",
      icon: "pix",
      empresa: "IGREJA GREENHOUSE",
      banco: "Banco Santander",
      agencia: "1109",
      conta: "13.000806-5",
      cnpj: " 32.708.437/0001-70",
      type: 2,
      link: null,
      info: "Se preferir faça um pix para o cnpj:"
    }];

  }
  /**
   * 
   * Inicilaiza as Funções
   * 
   */
  ngOnInit():void{
    this.getData();
    this.setOptions();
  }

}
